import Icon from '@mui/icons-material/Movie';

import { CreateSeries } from './CreateSeries';
import { EditSeries } from './EditSeries';
import { ListSeries } from './ListSeries';

export const SeriesResourceConfig = {
  list: ListSeries,
  create: CreateSeries,
  edit: EditSeries,
  icon: Icon,
  name: 'series',
};
